import React, {ReactNode, useMemo} from "react"
import {BreadcrumbItem, BreadcrumbsContext, useBreadcrumbs, useBreadcrumbsContext} from "./BreadcrumbsProvider"

interface BreadcrumbsLayerProps {
    items: BreadcrumbItem[]
    children: ReactNode
}

function BreadcrumbsLayer({items, children}: BreadcrumbsLayerProps) {
    useBreadcrumbs(items)

    const parent = useBreadcrumbsContext()
    const childValue = useMemo(
        () => ({...parent, depth: parent.depth + 1}),
        [parent],
    )

    return <BreadcrumbsContext.Provider value={childValue}>{children}</BreadcrumbsContext.Provider>
}

export default BreadcrumbsLayer
